import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section id="about" className="bg-white py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left: Lightbulb Illustration */}
          <div className="relative flex items-center justify-center h-[500px]">
            {/* Decorative blobs */}
            <div className="absolute -top-8 -left-8 w-40 h-40 bg-[#38BDF8]/20 rounded-full z-0" />
            <div className="absolute -bottom-8 -right-8 w-32 h-32 bg-[#F472B6]/20 rounded-full z-0" />
            <div className="absolute top-1/2 -right-4 w-20 h-20 bg-[#FBBF24]/30 rounded-xl rotate-12 z-0" />

            {/* Glow */}
            <div className="absolute w-72 h-72 rounded-full z-0" style={{ background: 'radial-gradient(circle, #FBBF2450 0%, #38BDF815 60%, transparent 80%)' }} />

            {/* Orbiting rings */}
            <div className="absolute w-80 h-80 rounded-full border-2 border-dashed border-[#FBBF24]/30 animate-spin z-0" style={{ animationDuration: '12s' }} />
            <div className="absolute w-96 h-96 rounded-full border border-dashed border-[#38BDF8]/20 animate-spin z-0" style={{ animationDuration: '18s', animationDirection: 'reverse' }} />

            {/* Floating idea tags */}
            <div className="absolute top-10 left-4 bg-[#FFF0F7] text-[#F472B6] text-xs font-black px-4 py-2 rounded-full z-10 animate-bounce" style={{ animationDuration: '3s', transform: 'rotate(-6deg)' }}>
              ブランディング ✨
            </div>
            <div className="absolute top-16 right-2 bg-[#E0F7FF] text-[#38BDF8] text-xs font-black px-4 py-2 rounded-full z-10 animate-bounce" style={{ animationDuration: '2.5s', animationDelay: '0.5s', transform: 'rotate(4deg)' }}>
              広告戦略 💡
            </div>
            <div className="absolute bottom-16 left-4 bg-[#F3FFEA] text-[#65A30D] text-xs font-black px-4 py-2 rounded-full z-10 animate-bounce" style={{ animationDuration: '3.5s', animationDelay: '1s', transform: 'rotate(5deg)' }}>
              デジタルマーケ 📱
            </div>
            <div className="absolute bottom-10 right-2 bg-[#FFFBEB] text-[#D97706] text-xs font-black px-4 py-2 rounded-full z-10 animate-bounce" style={{ animationDuration: '2.8s', animationDelay: '0.3s', transform: 'rotate(-4deg)' }}>
              クリエイティブ 🎨
            </div>

            {/* Main lightbulb */}
            <div className="relative z-10 flex flex-col items-center gap-5">
              <div className="w-52 h-52 flex items-center justify-center rounded-full" style={{ background: 'linear-gradient(135deg, #FBBF24, #FB923C)' }}>
                <i className="ri-lightbulb-flash-fill text-white" style={{ fontSize: '100px' }} />
              </div>
              {/* Bouncing dots */}
              <div className="flex gap-3">
                {['#38BDF8', '#F472B6', '#FBBF24', '#A3E635'].map((c, i) => (
                  <div
                    key={i}
                    className="w-4 h-4 rounded-full animate-bounce"
                    style={{ background: c, animationDelay: `${i * 0.2}s`, animationDuration: '1.5s' }}
                  />
                ))}
              </div>
            </div>

            {/* Floating badges */}
            <div className="absolute top-8 -right-6 bg-[#FBBF24] rounded-2xl p-4 z-20" style={{ transform: 'rotate(3deg)' }}>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center bg-white rounded-xl">
                  <i className="ri-star-fill text-[#FBBF24] text-sm" />
                </div>
                <div>
                  <p className="text-xs text-gray-700 font-bold">設立</p>
                  <p className="font-black text-sm text-gray-900">2021.7.21</p>
                </div>
              </div>
            </div>


          </div>

          {/* Right: Content */}
          <div>
            <div
              className="inline-flex items-center gap-2 text-xs font-black px-4 py-2 rounded-full mb-6 uppercase tracking-wider"
              style={{ background: '#E0F7FF', color: '#0EA5E9' }}
            >
              <i className="ri-user-star-fill" />
              About Us
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-gray-900 leading-tight mb-6">
              クリエイティブで、<br />
              <span
                style={{
                  background: 'linear-gradient(135deg, #38BDF8, #F472B6)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  backgroundClip: 'text',
                }}
              >
                世界を変える。
              </span>
            </h2>
            <p className="text-gray-600 leading-relaxed mb-5 text-sm md:text-base">
              Grandeur Architect株式会社は、2021年7月に設立された
              クリエイティブ広告代理店です。
              お客様のブランドを戦略的に設計し、最大の成果を生み出すことを
              使命としています。
            </p>
            <p className="text-gray-600 leading-relaxed mb-8 text-sm md:text-base">
              代表はクリエイティブ業界で豊富な経験を持つプロフェッショナル。
              感性と論理を融合させたアプローチで、中小企業から大手企業まで
              幅広いクライアントのブランド価値向上を支援してきました。
            </p>

            <div className="grid grid-cols-2 gap-3 mb-8">
              {[
                { icon: 'ri-lightbulb-fill', label: '広告戦略', color: '#38BDF8', bg: '#E0F7FF' },
                { icon: 'ri-palette-fill', label: 'ブランディング', color: '#F472B6', bg: '#FFF0F7' },
                { icon: 'ri-bar-chart-fill', label: 'デジタルマーケ', color: '#FBBF24', bg: '#FFFBEB' },
                { icon: 'ri-megaphone-fill', label: 'PR・宣伝', color: '#A3E635', bg: '#F3FFEA' },
              ].map((item) => (
                <div
                  key={item.label}
                  className="flex items-center gap-3 rounded-2xl p-4 font-bold text-sm cursor-default hover:scale-105 transition-transform"
                  style={{ background: item.bg, color: item.color }}
                >
                  <div className="w-9 h-9 flex items-center justify-center bg-white rounded-xl">
                    <i className={`${item.icon} text-base`} style={{ color: item.color }} />
                  </div>
                  {item.label}
                </div>
              ))}
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 font-black px-6 py-3.5 rounded-full cursor-pointer hover:scale-105 transition-all whitespace-nowrap text-white"
              style={{ background: 'linear-gradient(135deg, #38BDF8, #A3E635)' }}
            >
              詳しく見る
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
